module.exports = __webpack_public_path__ + "static/media/account-settings.e6d8421e.png";